<template>
	<div class="pageContainer">
		<PageHeader
			addClass="is-embedded"
			:image="require('../assets/embedded/title_pc.svg')"
			:imageSp="require('../assets/embedded/title_sp.svg')"
			alt="豆蔵の根幹であるシステムズエンジニアリングやソフトウェアエンジニアリングで業界をリードする"
			intro="エンベデッド領域(自動車やロボットといった製品の機能を実現するためのソフトウェア)では、<br class='over_display'>オブジェクト指向やモデルベースによる抽象化技術を含めたシステムズエンジニアリングや、<br class='over_display'>ソフトウェアエンジニアリングといったものづくりにおける原理原則を踏まえて、<br class='over_display'>教育やコンサルティングを実施しています。その強みやプロジェクト事例について紹介します。"
		/>
		<BgTitleBox
			:bgPc="require('../assets/embedded/bgBox_pc.jpg')"
			:bgSp="require('../assets/embedded/bgBox_sp.jpg')"
			title="エンベデッド領域の概要"
		/>
		<EmbeddedArticle />
	</div>
</template>

<script>
import PageHeader from '@/components/mainpage/PageHeader.vue';
import BgTitleBox from '@/components/common/BgTitleBox.vue';
import EmbeddedArticle from '@/components/mainpage/EmbeddedArticle.vue';
export default {
	name: 'embedded',
	components: {
		PageHeader,
		BgTitleBox,
		EmbeddedArticle,
	},
};
</script>

<style lang="scss" scoped>
.pageContainer {
	position: relative;
	overflow: hidden;
	width: 100%;
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 100px;
	}
}
</style>
